import { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: ReactNode;
}

// Guarda de rota para /admin. Regras de segurança:
// - Só deixa passar quem está autenticado E tem tipo === 'admin'.
// - Qualquer outro usuário autenticado (profissional ou empresa) é deslogado
//   automaticamente e enviado para a página genérica de Acesso Negado.
// - Um visitante sem sessão também vê a mesma página genérica (sem redirecionar
//   para o login, para não sugerir que basta entrar com qualquer conta).
//
// Isto é apenas a camada de UX: a proteção real dos dados é feita no backend
// pelo middleware requireAdmin, que valida o tipo do usuário a partir do token.
export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { user, loading, logout } = useAuth();
  const [encerrandoSessao, setEncerrandoSessao] = useState(false);
  const logoutDisparado = useRef(false);

  const usuarioNaoAdmin = !loading && !!user && user.tipo !== 'admin';

  useEffect(() => {
    if (usuarioNaoAdmin && !logoutDisparado.current) {
      logoutDisparado.current = true;
      setEncerrandoSessao(true);
      logout();
    }
  }, [usuarioNaoAdmin, logout]);

  if (loading || encerrandoSessao) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
      </div>
    );
  }

  if (!user || user.tipo !== 'admin') {
    return <Navigate to="/acesso-negado" replace />;
  }

  return <>{children}</>;
};
